import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { ProfileIcon, ChevronRight } from '../../Components/Icons/Icons';
import Layout from '../Layout/Layout';

import './admindashboard.scss';
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";

const AdminDashboard = ({ event }) => {

    const [response, setResponse] = useState({
        pending_invitations_count: 0,
        submissions_count: 0,
        invitation_sent: 0,
        rsvp_received: 0,
        rsvp_received_pr: 0,
        registration_submitted: 0,
        registration_submitted_pr: 0,
        inventory: [{
            package: { name: '-' },
            wave: { name: '-' }
        }],
        pending_invitations: [],
        submissions: [],
        pending_invitations_count: 0,
        comms_errors_count: 0,
        comms_errors: []
    });

    async function fetchDashboardData() {
        await adminHttp.get('/events/' + event.id + '/dashboard')
            .then(res => {
                setResponse(res.data)
            });
    }

    useEffect(() => {
        fetchDashboardData();
    }, [event]);

    return (
        <Layout page="admin-dashboard">
            <div className="container-fluid">
                <div className="row no-gutters">
                    <h1 className="col-12">Event Dashboard</h1>

                    <div className="reg-overview-card col-12 card grid-gap">
                        <div className="d-flex flex-column">
                            <h3 className="mb-1">Registration Overview</h3>
                            <Link to="/guests/registration" className="link text-primary">View all registrations</Link>
                        </div>
                        <div className="d-flex">
                            <h4 className="mr-2 mb-0">{response.invitation_sent}</h4>
                            <div>
                                <h6 className="mb-1">Invitation Sent</h6>
                                <p className="mb-0"></p>
                            </div>
                        </div>
                        <div className="d-flex">
                            <h4 className="mr-2 mb-0">{response.rsvp_received}</h4>
                            <div>
                                <h6>RSVP Received</h6>
                                <p>{response.rsvp_received_pr}%</p>
                            </div>
                        </div>
                        <div className="d-flex">
                            <h4 className="mr-2 mb-0">{response.registration_submitted}</h4>
                            <div>
                                <h6>Registration submitted</h6>
                                <p>{response.registration_submitted_pr}%</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 row no-gutters mt-3 row-gap-20">

                        <div className="col-xl-6 col-lg-12 pr-xl-3 pr-lg-0 mb-3 mb-sm-0">
                            <div className="card">
                                <h3>Available Inventory</h3>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>QTY</th>
                                            <th>Package</th>
                                            <th>Wave</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {response?.inventory.map((i, key) => (
                                            <tr key={key}>
                                                <th>{0}</th>
                                                <th>{i.package?.name || '-'}</th>
                                                <th>{i.wave?.name || '-'}</th>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Link to="/inventory" className="link text-primary mt-auto">View inventory</Link>
                            </div>
                        </div>

                        <div className="col-xl-3 col-lg-12 pr-xl-3 pr-lg-0 mb-3 mb-sm-0">
                            <div className="card">
                                <h2 className="mb-1">{response.pending_invitations_count}</h2>
                                <h5 className="mb-0">Pending Invitations</h5>
                                <div className="list">
                                    {response.pending_invitations.map((i, key) => (
                                        <div className="list__single" key={key}>
                                            <ProfileIcon />
                                            <div>
                                                <h4 className="text-subhead">{i.main_guest?.full_name || i.user.full_name}</h4>
                                                <p className="text-caption">{i.main_guest?.email || i.user.email}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <Link to="/guests/invitation" className="link text-primary mt-auto">View all invitations</Link>
                            </div>
                        </div>

                        <div className="col-xl-3 col-lg-12 mb-3 mb-sm-0">
                            <div className="card">
                                <h2 className="mb-1">{response.comms_errors_count}</h2>
                                <h5 className="mb-0">Email Errors</h5>
                                <div className="list">
                                    {response.comms_errors?.map((s, key) => (
                                        <div className="list__single justify-content-between align-items-center" key={key}>
                                            <div className="d-flex">
                                                <ProfileIcon />
                                                <div>
                                                    <h4 className="text-subhead">{s.name}</h4>
                                                    <p className="text-caption">{s.email}</p>
                                                </div>
                                            </div>
                                            <Link to={`/communication/${s.id}`}>
                                                <ChevronRight />
                                            </Link>
                                        </div>
                                    ))}
                                </div>

                                <Link to="/communication" className="link text-primary mt-auto">View all communication</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </Layout>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminDashboard);
